module.exports = __webpack_public_path__ + "static/media/community-driven-growth-first@3x.c4597aa0.jpg";